<template>
  <fa-icon icon="users" />
</template>
